import { render, staticRenderFns } from "./AdsSourceInfo.vue?vue&type=template&id=35da2c5a&scoped=true"
import script from "./AdsSourceInfo.vue?vue&type=script&lang=js"
export * from "./AdsSourceInfo.vue?vue&type=script&lang=js"
import style0 from "./AdsSourceInfo.vue?vue&type=style&index=0&id=35da2c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35da2c5a",
  null
  
)

export default component.exports